import { useEffect } from 'react'
import { setWorkspacePreference } from '~/services/preferences/workspacePreferences'
import { getQueryOptions } from '~/services'
import { createFileRoute } from '@tanstack/react-router'
import { WebchatOnboarding } from '~/features/bots/components'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/new-chat')({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      getQueryOptions('workspaces_/$workspaceId_/preferences/$path', {
        path: 'onBoardingCompleted',
        workspaceId: params.workspaceId,
        params: { botId: params.botId }, // to satisfy the type but not used in the key
      })
    ),
})

function RouteComponent() {
  const { workspaceId, botId } = Route.useParams()
  const onboardingCompleted = Route.useLoaderData()

  useEffect(() => {
    const onFirstOnboardingCompleted = () => {
      setWorkspacePreference(
        {
          path: 'onBoardingCompleted',
          value: true,
        },
        workspaceId
      )
    }

    if (onboardingCompleted === false) {
      onFirstOnboardingCompleted()
    }
  }, [])

  return <WebchatOnboarding botId={botId} workspaceId={workspaceId} />
}
